import { Component, Input, OnInit } from '@angular/core';
import { AlarmsLibService } from '../../services/libraries/alarms-lib.service';
import { ReportsService } from '../reports.service';
import {
  CostsReportsDataModel,
  CreatedReportModel,
  ReportRequestData,
} from '../reports.model';
import { TimeLibService } from '../../services/libraries/time-lib.service';
import {
  PlatformLibService,
  TranslationsLibService,
  HelpersLibService,
  FieldsService,
} from '@nutricontrol/app360-shared';

@Component({
  selector: 'app-reports-costs',
  templateUrl: './reports-costs.component.html',
  styleUrls: ['./reports-costs.component.scss'],
  animations: [],
})
export class ReportsCostsComponent implements OnInit {
  @Input() createdReport: CreatedReportModel;
  loader = true;
  costsReportsData?: CostsReportsDataModel;
  requestData: ReportRequestData;
  ready = false;
  reportName = '';
  isNative = false;
  constructor(
    private alarmsLib: AlarmsLibService,
    private helpersLib: HelpersLibService,
    private reportsService: ReportsService,
    private fieldService: FieldsService,
    private timeLib: TimeLibService,
    private platformLib: PlatformLibService,
    public translationsLib: TranslationsLibService
  ) {}
  ngOnInit() {
    this.isNative = this.platformLib.isNative();
    this.resetAll();
    this.processReportCosts();
  }
  getOrientation(): string {
    if (window.innerWidth < 700) {
      return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
    } else {
      //si es suficientemente ancho nos da igual
      return 'landscape';
    }
  }
  private processReportCosts(): void {
    const begin = this.timeLib.beginDate(
      this.createdReport.dateRange.start,
      0,
      'days'
    );
    const end = this.timeLib.endDate(
      this.createdReport.dateRange.end,
      0,
      'days'
    );
    const terminalsVid = this.createdReport.terminals.map(
      (terminalReport) => terminalReport.vid
    );

    this.loader = true;

    this.reportsService
      .getIrrigationCostReport({ terminals_vid: terminalsVid }, begin, end)
      .subscribe((res) => {
        if (
          res.irrigation_costs_reports !== undefined &&
          res.irrigation_costs_reports.length > 0
        ) {
          this.costsReportsData = res.irrigation_costs_reports[0];
          console.log('#333#', this.costsReportsData);
          // this.helpersLib.sendEventPageView(
          //   // TODO. ANALYTICS PAGE VIEW EVENT
          //   'Reports | Costs | ' + Array(terminalsVid).join(' - ')
          // );
          this.loader = false;
        }
      });

    // this.loader = false;
    // this.costsReportsData = this.demoData();
  }
  private resetAll() {
    this.costsReportsData = undefined;
  }

  public hasReportsData() {
    return this.costsReportsData.items.length > 0;
  }
}
